import { type } from 'type-r'
import moment from 'moment'

export function parseDate(val) {
    if (typeof val == 'string') {
        if (val.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/))
            return moment(val).toDate();
        else
            return moment(val, 'MMM DD hh:mmA').toDate();
    }
    else if (typeof val == 'number') {
        if (val.toString().length == 10)
            return moment.unix(val).toDate();
        else
            return moment(val).toDate();
    }
    else return val;
}
var PowerDate = type(Date).parse(parseDate);
export default PowerDate;
